module.exports = __webpack_public_path__ + "static/media/th-large.c82b223c.svg";